import { render, staticRenderFns } from "./dataDoardDialog.vue?vue&type=template&id=313c0950&scoped=true"
import script from "./dataDoardDialog.vue?vue&type=script&lang=js"
export * from "./dataDoardDialog.vue?vue&type=script&lang=js"
import style0 from "./dataDoardDialog.vue?vue&type=style&index=0&id=313c0950&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313c0950",
  null
  
)

export default component.exports